import { useEffect } from 'react';

import MetaConversionsAPI from '../trackings/MetaConversionsAPI';
import { splitFullName } from '../utils/splitFullName';
import { useUserContext } from './contexts/user.context';

/**
 * Custom hook to automatically track Meta Conversions API PageView
 * when user authentication state changes.
 *
 * This hook handles:
 * - Tracking PageView events for both authenticated and anonymous users
 * - Safely splitting user full name into first and last name
 * - Sending appropriate user data (email, name, external_id) when available
 * - Reacting only to user ID changes to prevent unnecessary re-tracking
 *
 * @example
 * // In any page component
 * function MyPage() {
 *   useMetaConversions();
 *   // rest of component code...
 * }
 */
export const useMetaConversions = () => {
  const { user } = useUserContext();

  useEffect(() => {
    if (user) {
      const { first, last } = splitFullName(user.name);
      MetaConversionsAPI.trackPageView({
        email : user.email,
        first_name : first,
        last_name : last,
        external_id : String(user.id),
      });
      return;
    }

    MetaConversionsAPI.trackPageView();
  }, [user?.id]);
};
